<script setup lang="ts">
defineProps({
    image: {
        type: Object,
        required: false,
    },
    name: {
        type: String,
        required: true,
    },
    link: {
        type: Object,
        required: false,
    },
    description: {
        type: String,
        required: false,
    },
})
</script>

<template>
    <div class="flex flex-col items-center gap-6">
        <a
            v-if="link?.url"
            :href="link?.url"
            target="_blank"
            class="h-[185px] flex items-end max-[641px]:h-auto"
        >
            <img
                v-if="image?.filename"
                :src="image?.filename"
                :alt="image?.alt"
                class="mix-blend-multiply"
            >
        </a>
        <div
            v-else
            class="h-[185px] flex items-end"
        >
            <img
                v-if="image?.filename"
                :src="image?.filename"
                :alt="image?.alt"
                class="mix-blend-multiply"
            >
        </div>
        <div class="flex flex-col items-center gap-2">
            <div class="w-[50px] h-px bg-chsc-text" />
            <p class="font-eb-garamond fs-xl text-center">
                {{ name }}
            </p>
            <div class="w-[50px] h-px bg-chsc-text" />
            <p
                v-if="description"
                class="text-center fs-lg font-eb-garamond"
            >
                {{ description }}
            </p>
        </div>
    </div>
</template>
